import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik } from 'formik';
import { observer } from 'mobx-react';
import { useContext, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { storesContext } from '../../../../stores/storesContext';
import { errorToast, successToast } from '../../../helpers/toasts/ToastUtils';
import MonitoringForm from './MonitoringForm';

const CreateMonitoringModal = ({ monitoringBlock }) => {
  const userStore = useContext(storesContext);
  const alcmStore = userStore.alcmStore;

  const [open, setOpen] = useState(false);

  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  return (
    <>
      <Button
        onClick={() => {
          show();
        }}
      >
        <FontAwesomeIcon icon={faPlus} /> Add Monitoring
      </Button>
      <Modal backdrop='static' size='md' show={open} onHide={() => hide()}>
        <Modal.Header closeButton>
          <Modal.Title>
            Create Monitoring for <b>{monitoringBlock.block_id}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={{
              block_id: monitoringBlock.id,
              date: '',
              amount: '',
              type: ''
            }}
            validate={(values) => {
              const errors = {};
              if (!values.date) errors.date = 'Required';
              if (!values.amount && values.amount !== 0)
                errors.amount = 'Required';
              else if (values.amount < 0)
                errors.amount = 'Must be 0 or greater';
              if (!values.type) errors.type = 'Required';
              return errors;
            }}
            onSubmit={async (values, actions) => {
              try {
                await alcmStore.createMonitoring({
                  block_id: values.block_id,
                  date: values.date,
                  amount: values.amount,
                  type: values.type
                });
                successToast('Monitoring created successfully.');
                hide();
              } catch (err) {
                errorToast('Failed to create monitoring.');
              } finally {
                actions.setSubmitting(false);
              }
            }}
          >
            {() => {
              return <MonitoringForm onCancel={hide} />;
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default observer(CreateMonitoringModal);

